<template>
  <Layout>
    <div v-if="aupairs && aupairs.length > 0">
      <h2 class="page-title mb-5">Your Interview Requests</h2>

      <ul class="flex flex-col md:flex-row flex-wrap items-start">
        <li
          class="w-full md:w-1/2 sm:px-1"
          v-for="(aupair, index) in aupairs"
          :key="index"
        >
          <AuPairShortCard :aupair="aupair" class="overflow-hidden relative">
            <Ribbon
              :ribbonLabel="
                requestInterviewStatusToText(aupair.interviewStatus)
              "
            />
            <div
              v-if="!isMatched && aupair.interviewStatus !== 'C'"
              class="-mx-3 p-2 flex items-center justify-around border-t border-purple-ap-t03"
            >
              <router-link
                class="text-sm"
                tag="a"
                :to="{
                  name: 'Profile',
                  params: { id: aupair.auPairPromoProfileId },
                }"
                >View Profile</router-link
              >
              <button
                v-if="aupair.interviewStatus !== 'A'"
                class="text-sm text-red-600"
                @click.prevent="cancelInterview(aupair)"
              >
                Cancel Interview
              </button>
            </div>

            <div
              v-if="!isMatched && aupair.interviewStatus !== 'C'"
              class="-mx-3 flex items-center justify-around border-b border-purple-ap-t03"
            >
              <button
                @click.prevent="requestMatch(aupair)"
                class="btn btn-purple text-white text-sm uppercase rounded-none w-full"
              >
                SHOW INTEREST IN AU PAIR
              </button>
            </div>
          </AuPairShortCard>

          <div v-if="!isMatched"></div>
        </li>
      </ul>
    </div>
    <div
      class="w-full max-w-4xl m-auto overflow-hidden shadow-lg bg-white mb-4 rounded-b-lg rounded-t p-5"
      v-else-if="aupairs && aupairs.length == 0"
    >
      <p class="text-center text-2xl">
        You have no interview requests at this moment.
      </p>
    </div>
    <ComponentLoading v-else />
  </Layout>
</template>

<script>
import { api } from "@/services.js";
import Layout from "@/Layout/Authenticated/Layout.vue";
import AuPairShortCard from "@/components/AuPairs/AuPairShortCard.vue";
import Ribbon from "@/components/UI/Ribbon.vue";

export default {
  name: "RequestInterview",
  components: {
    AuPairShortCard,
    Ribbon,
    Layout,
  },
  data() {
    return {
      aupairs: null,
    };
  },
  created() {
    if (this.$store.state.user.match) {
      this.$router.push({
        name: "Home",
      });
    } else {
      this.pullData();
    }
  },
  computed: {
    isMatched() {
      return this.$store.state.user.matchRequest ? true : false;
    },
  },
  methods: {
    pullData() {
      this.aupairs = null;
      api
        .get("/promotional/AuPairPromoProfiles/interviews")
        .then((r) => {
          this.aupairs = r.data;

          if (this.aupairs && this.aupairs.length === 0) {
            this.$router.push({
              name: "FavoriteAuPairs",
            });
          }
        })
        .catch((error) => {
          this.$toasted.global.notificate({
            message: error.response.data.message,
            type: "error",
          });
        });
    },
    cancelInterview(aupair) {
      this.$router.push({
        name: "CancelInterviewConfirmation",
        params: { aupair: aupair },
      });
    },
    requestMatch(aupair) {
      this.$router.push({
        name: "MatchConfirmation",
        params: { aupair: aupair },
      });
    },
    requestInterviewStatusToText(status) {
      switch (status) {
        case "R":
          return "Requested";

        case "C":
          return "Cancelled";

        case "A":
          return "Approved";
      }
    },
  },
};
</script>
